import React from 'react';

function Wave({ svgFill = '#f0f0f0', pathStroke = 'white', pathStrokeWidth = 8, pathFill = 'transparent' }) {
    return (
        <div className="-mt-40 py-8">
            <svg
                viewBox="0 0 500 100"
                fill={svgFill}
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-auto"
            >
                <path
                    d="M0 5 C 100 0, 200 100, 300 50 S 500 100, 500 40"
                    stroke={pathStroke}
                    strokeWidth={pathStrokeWidth}
                    strokeDasharray="20 20"
                    fill={pathFill}
                />
            </svg>
        </div>
    );
}

export default Wave;
